import { MGPOptional, MGPValidation } from '@everyboard/lib';
import { GameNode } from '../../jscaip/AI/GameNode';
import { Coord } from '../../jscaip/Coord';
import { GameStatus } from '../../jscaip/GameStatus';
import { Player, PlayerOrNone } from '../../jscaip/Player';
import { PlayerMap } from '../../jscaip/PlayerMap';
import { Rules } from '../../jscaip/Rules';
import { RulesFailure } from '../../jscaip/RulesFailure';
import { TableUtils } from '../../jscaip/TableUtils';
import { Vector } from '../../jscaip/Vector';
import { PentagoFailure } from './PentagoFailure';
import { PentagoState } from './PentagoState';
export class PentagoNode extends GameNode {
}
export class PentagoRules extends Rules {
    static singleton = MGPOptional.empty();
    static get() {
        if (PentagoRules.singleton.isAbsent()) {
            PentagoRules.singleton = MGPOptional.of(new PentagoRules());
        }
        return PentagoRules.singleton.get();
    }
    getInitialState() {
        const initialBoard = TableUtils.create(PentagoState.SIZE, PentagoState.SIZE, PlayerOrNone.NONE);
        return new PentagoState(initialBoard, 0);
    }
    static VICTORY_SOURCE = [
        // [ firstCoordToTest, directionToTest, shouldLookTheSpaceBeforeAsWellAsSpaceAfter]
        [new Coord(1, 0), new Vector(1, 1), false], // 4 short diagonals
        [new Coord(0, 1), new Vector(1, 1), false],
        [new Coord(4, 0), new Vector(-1, 1), false],
        [new Coord(5, 1), new Vector(-1, 1), false],
        [new Coord(1, 1), new Vector(1, 1), true], // 2 long diagonals
        [new Coord(4, 1), new Vector(-1, 1), true],
        [new Coord(0, 1), new Vector(0, 1), true], // 6 verticals
        [new Coord(1, 1), new Vector(0, 1), true],
        [new Coord(2, 1), new Vector(0, 1), true],
        [new Coord(3, 1), new Vector(0, 1), true],
        [new Coord(4, 1), new Vector(0, 1), true],
        [new Coord(5, 1), new Vector(0, 1), true],
        [new Coord(1, 0), new Vector(1, 0), true], // 6 horizontal
        [new Coord(1, 1), new Vector(1, 0), true],
        [new Coord(1, 2), new Vector(1, 0), true],
        [new Coord(1, 3), new Vector(1, 0), true],
        [new Coord(1, 4), new Vector(1, 0), true],
        [new Coord(1, 5), new Vector(1, 0), true],
    ];
    applyLegalMove(move, state, _config, _info) {
        return state.applyLegalMove(move);
    }
    isLegal(move, state) {
        if (state.getPieceAt(move.coord).isPlayer()) {
            return MGPValidation.failure(RulesFailure.MUST_LAND_ON_EMPTY_SPACE());
        }
        const postDropState = state.applyLegalDrop(move);
        if (postDropState.neutralBlocks.length === 0) {
            if (move.blockTurned.isAbsent()) {
                return MGPValidation.failure(PentagoFailure.MUST_CHOOSE_BLOCK_TO_ROTATE());
            }
        }
        else {
            if (move.blockTurned.isPresent()) {
                const blockTurned = move.blockTurned.get();
                if (postDropState.neutralBlocks.includes(blockTurned)) {
                    return MGPValidation.failure(PentagoFailure.CANNOT_ROTATE_NEUTRAL_BLOCK());
                }
            }
        }
        return MGPValidation.SUCCESS;
    }
    getVictoryCoords(state) {
        let victoryCoords = [];
        for (const maybeVictory of PentagoRules.VICTORY_SOURCE) {
            const firstValue = state.getPieceAt(maybeVictory[0]);
            const subVictory = [maybeVictory[0]];
            if (firstValue.isPlayer()) {
                let testedCoord = maybeVictory[0].getNext(maybeVictory[1]);
                let fourAligned = true;
                for (let i = 0; i < 3 && fourAligned; i++) {
                    if (state.getPieceAt(testedCoord) !== firstValue) {
                        fourAligned = false;
                    }
                    else {
                        subVictory.push(testedCoord);
                        testedCoord = testedCoord.getNext(maybeVictory[1]);
                    }
                }
                if (fourAligned) {
                    // check first alignment
                    if (state.getPieceAt(testedCoord) === firstValue) {
                        subVictory.push(testedCoord);
                        victoryCoords = victoryCoords.concat(subVictory);
                    }
                    if (maybeVictory[2]) {
                        const coordZero = maybeVictory[0].getPrevious(maybeVictory[1], 1);
                        if (state.getPieceAt(coordZero) === firstValue) {
                            subVictory.push(coordZero);
                            victoryCoords = victoryCoords.concat(subVictory);
                        }
                    }
                }
            }
        }
        return victoryCoords;
    }
    getGameStatus(node) {
        const state = node.gameState;
        const victoryCoords = this.getVictoryCoords(state);
        const victoryFound = PlayerMap.ofValues(false, false);
        for (let i = 0; i < victoryCoords.length; i += 5) {
            victoryFound.put(state.getPieceAt(victoryCoords[i]), true);
        }
        if (victoryFound.get(Player.ZERO)) {
            if (victoryFound.get(Player.ONE)) {
                return GameStatus.DRAW;
            }
            else {
                return GameStatus.ZERO_WON;
            }
        }
        if (victoryFound.get(Player.ONE)) {
            return GameStatus.ONE_WON;
        }
        if (state.turn === PentagoState.SIZE * PentagoState.SIZE) {
            return GameStatus.DRAW;
        }
        else {
            return GameStatus.ONGOING;
        }
    }
}
